import axios from '../axios'

// レッスン教材の更新（名前・リンク）
const putLessonMaterialApi = async (materialId, payload) => {
  return await axios.put(`api/lms/lesson-materials/${materialId}`, payload)
}

export default putLessonMaterialApi
